export const PLATFORM_IDS = {
    YOUTUBE: "youtube",
    ZOOM: "zoom",
    TEAMS: "teams",
    OBS: "obs",
    CUSTOM: "custom",
};

export const PLATFORMS = {
    [PLATFORM_IDS.YOUTUBE]: {
        id: PLATFORM_IDS.YOUTUBE,
        label: "YouTube Live",
        endpointLabel: "Caption Ingestion URL",
        authLabel: "Ingestion URL",
        endpointPlaceholder: "https://upload.youtube.com/closedcaption?...",
        endpointHelp: "Paste the Caption Ingestion URL from YouTube Studio.",
        defaultMaxChars: 32,
        supportsChannel: false,
        supportsLatency: true,
        supportsRegion: true,
        supportsSeq: true,
        requiresEndpoint: true,
    },
    [PLATFORM_IDS.ZOOM]: {
        id: PLATFORM_IDS.ZOOM,
        label: "Zoom",
        endpointLabel: "CART URL",
        authLabel: "API Token",
        endpointPlaceholder: "https://wmcc.zoom.us/closedcaption?id=...",
        endpointHelp: "Paste the meeting CART URL from the Zoom host. It is only valid for the active meeting.",
        defaultMaxChars: 80,
        supportsChannel: false,
        supportsLatency: false,
        supportsSeq: false,
        requiresEndpoint: true,
    },
    [PLATFORM_IDS.TEAMS]: {
        id: PLATFORM_IDS.TEAMS,
        label: "Microsoft Teams",
        endpointLabel: "CART URL",
        authLabel: "API Token",
        endpointPlaceholder: "https://api.captioning.teams.microsoft.com/...",
        endpointHelp: "Paste the CART URL generated from Meeting Options. Teams recommends 80-120 characters per request.",
        defaultMaxChars: 80,
        supportsChannel: false,
        supportsLatency: false,
        supportsSeq: false,
        requiresEndpoint: true,
    },
    [PLATFORM_IDS.OBS]: {
        id: PLATFORM_IDS.OBS,
        label: "OBS Studio",
        endpointLabel: "OBS WebSocket Address",
        authLabel: "Password",
        endpointPlaceholder: "localhost:4455",
        endpointHelp: "Enter the OBS WebSocket host and port. OBS WebSocket v5 defaults to port 4455.",
        defaultMaxChars: 32,
        supportsChannel: true,
        supportsLatency: false,
        supportsSeq: false,
        requiresEndpoint: true,
    },
    [PLATFORM_IDS.CUSTOM]: {
        id: PLATFORM_IDS.CUSTOM,
        label: "Custom URL",
        endpointLabel: "Endpoint URL",
        authLabel: "Authorization Header",
        endpointPlaceholder: "https://example.com/captions",
        endpointHelp: "Plain UTF-8 text will be POSTed to this URL.",
        defaultMaxChars: 80,
        supportsChannel: true,
        supportsLatency: false,
        supportsSeq: false,
        requiresEndpoint: true,
    },
};

export const PLATFORM_OPTIONS = Object.values(PLATFORMS);

export function getPlatformConfig(platform) {
    return PLATFORMS[platform] || PLATFORMS[PLATFORM_IDS.YOUTUBE];
}
